import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { ResponsiveFunnel } from '@nivo/funnel'
import get from 'lodash.get'
import { useFormattingContext } from '../../../FormattingProvider/FormattingContext'
import { useFirmReportData } from '../../../../../api/coreData'
import { useDenaliFilter } from '../../filters/DenaliFilterContextProvider'

const useFormatters = (valueFormat) => {
  const { formatter } = useFormattingContext()

  return useCallback(d => {
    return formatter(d, valueFormat)
  }, [formatter, valueFormat])
}

function DenaliFunnel ({
  reportId,
  baseQuery,
  height,
  idAccessor,
  valueAccessor,
  labelAccessor,
  valueFormat,
  ...chartProps
}) {
  const { filter, membershipFilter } = useDenaliFilter()
  const query = useMemo(() => {
    return {
      ...baseQuery,
      membershipFilter,
      filters: {
        ...(filter || {}),
        ...(baseQuery?.filters || {})
      },
      reportId
    }
  }, [reportId, baseQuery, filter, membershipFilter])

  const valueFormatter = useFormatters(valueFormat)
  const { data: report, isLoading } = useFirmReportData(query)
  const chartData = useMemo(() => {
    return (report?.data || []).map(item => ({
      id: get(item, idAccessor),
      value: get(item, valueAccessor),
      label: get(item, labelAccessor)
    }))
  }, [report, idAccessor, valueAccessor, labelAccessor])

  if (isLoading) return null

  return (
    <div style={{ height }}>
      <ResponsiveFunnel
        theme={{
          fontFamily: 'var(--root-font) !important',
          fontSize: '12px'
        }}
        data={chartData}
        valueFormat={valueFormatter}
        {...chartProps}
      />
    </div>
  )
}

DenaliFunnel.propTypes = {
  reportId: PropTypes.string,
  baseQuery: PropTypes.object,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  idAccessor: PropTypes.string,
  valueAccessor: PropTypes.string,
  labelAccessor: PropTypes.string,
  valueFormat: PropTypes.string
}

DenaliFunnel.defaultProps = {
  valueFormat: 'marketValue',
  height: 300
}

export default DenaliFunnel
